import { render, staticRenderFns } from "./view-whole-sale.vue?vue&type=template&id=2261fd3d&"
import script from "./view-whole-sale.vue?vue&type=script&lang=js&"
export * from "./view-whole-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports